import React from 'react';
import { connect } from 'react-redux';
import StatisticsByReactivationSegments from './StatisticsByReactivationSegments';

const StatisticsByReactivationSegmentsComponent = connect(
    function mapStateToProps(state) {
        return {
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
        };
    }
)(StatisticsByReactivationSegments);

export default StatisticsByReactivationSegmentsComponent;
